import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState, } from "react";
import { useLocation } from "@/location/hooks/useLocation";
import { DEFAULT_STYLE } from "../constants";
import { createInitialViewport } from "../utils/createInitialViewport";
export const MapContext = createContext(undefined);
export const MapProvider = ({ children }) => {
    const { geometry } = useLocation() || {};
    const [viewport, setViewport] = useState(() => createInitialViewport(geometry));
    const [isStyleLoaded, setIsStyleLoaded] = useState(false);
    const [style, setStyle] = useState(DEFAULT_STYLE);
    const [layers, setLayers] = useState({
        sunlight: false,
        pofi_subway_line: false,
        pofi_train_line: false,
        pofi_tram_line: false,
        poi: false,
    });
    const date = new Date();
    const minutesSinceMidnight = date.getHours() * 60 + date.getMinutes();
    const [time, setTime] = useState(minutesSinceMidnight);
    const [error, setError] = useState(null);
    const [is3DMode, setIs3DMode] = useState(false);
    const [initialLights, setInitialLights] = useState([]);
    const [isSidebarOpen, setIsSidebarOpen] = useState(true); // SHOULD BE TRUE, ONLY FOR LOCAL
    const [loadingState, setLoadingState] = useState("idle");
    const [travelTimes, setTravelTimes] = useState([]);
    const [destination, setDestination] = useState(undefined);
    const resetTravelTime = useCallback(() => {
        setTravelTimes([]);
        setLoadingState("idle");
        setDestination(undefined);
    }, []);
    const updateViewport = useCallback((partial) => {
        setViewport((prev) => typeof partial === "function" ? partial(prev) : Object.assign(Object.assign({}, prev), partial));
    }, []);
    const handleClose = useCallback(() => {
        resetTravelTime();
    }, [resetTravelTime]);
    const value = useMemo(() => {
        return {
            isStyleLoaded,
            style,
            viewport,
            error,
            setStyle,
            updateViewport,
            setError,
            is3DMode,
            setIs3DMode,
            handleClose,
            layers,
            setLayers,
            time,
            setTime,
            initialLights,
            setInitialLights,
            loadingState,
            setLoadingState,
            travelTimes,
            setTravelTimes,
            resetTravelTime,
            isSidebarOpen,
            setIsSidebarOpen,
            destination,
            setDestination,
            setIsStyleLoaded,
        };
    }, [
        isStyleLoaded,
        style,
        viewport,
        layers,
        error,
        is3DMode,
        handleClose,
        time,
        initialLights,
        loadingState,
        setLoadingState,
        travelTimes,
        setTravelTimes,
        resetTravelTime,
        isSidebarOpen,
        setIsSidebarOpen,
        destination,
        setDestination,
        updateViewport,
        setInitialLights,
        setIsStyleLoaded,
    ]);
    return _jsx(MapContext.Provider, { value: value, children: children });
};
export const useMapContext = () => {
    const context = useContext(MapContext);
    if (context === undefined) {
        throw new Error("useMapContext must be used within a MapProvider");
    }
    return context;
};
